import { createStore, compose } from 'redux'
import rootReducer from '../reducers'

// enable redux devtools... can this be done with Webpack instead?
const enhancers = compose(
  window.devToolsExtension ? window.devToolsExtension() : f => f,
)

export default initialState => createStore(rootReducer, initialState, enhancers);



// WEBPACK FOOTER //
// ./src/store/configure-store.js